<template>
  <div id="generate-document">
    <GlobalLoading v-if="isLoading" />
    <div class="document-container">
      <div ref="document">
        <VendorBadanUsahaBCE />

        <!-- page break -->
        <div class="html2pdf__page-break" />
        <!--  -->

        <VendorBadanUsahaGEMS />
      </div>
    </div>

    <button class="floating-button" @click="exportToPDF">Export to PDF</button>
    <button class="top-floating-button" @click="exportToPDF">
      Export to PDF
    </button>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    VendorBadanUsahaBCE: () => import('@/views/PDF/VendorBadanUsahaBCE'),
    VendorBadanUsahaGEMS: () => import('@/views/PDF/VendorBadanUsahaGEMS'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      akta: [
        {
          id: 1,
          name:
            'Akta Pendirian Perseroan  dan Pengesahan dari Instansi yang berwenang atas Anggaran Dasar. *',
        },
        {
          id: 2,
          name:
            'Akta penyesuaian PT sesuai dengan Undang-undang No. 40 tahun 2007 dan Pengesahan dari Instansi yang berwenang atas Anggaran Dasar. *',
        },
        {
          id: 3,
          name:
            'Anggaran Dasar terakhir Perseroan / BNRI terakhir dan Pengesahan dari Instansi yang berwenang atas Anggaran Dasar. *',
        },
        {
          id: 4,
          name:
            'Akta perubahan pengurus terakhir Perseroan dan Persetujuan/Penerimaan Pemberitahuan dari Instansi yang berwenang. *',
        },
      ],
      komersil: [
        { id: 5, name: 'NPWP (Nomor Pokok Wajib Pajak).' },
        { id: 6, name: 'SK Pengukuhan Pengusaha Kena Pajak (PKP).' },
        { id: 8, name: 'SKT (Surat Keterangan Terdaftar) Pajak.' },
        { id: 34, name: 'Halaman depan buku tabungan/cek/giro' },
        {
          id: 3536,
          name:
            'KTP semua Direksi & Komisaris yang masih berlaku sesuai Anggaran Perubahan Terakhir.',
        },
        { id: 9, name: 'Company Profile.' },
        {
          id: 10,
          name: 'Finiancial Report/ Annual Report 2-5 tahun terakhir.',
        },
      ],
      izin: [
        { id: 12, name: 'NIB (Nomor Induk Berusaha).' },
        { id: 14, name: 'SIUP (Surat Izin Usaha Perdagangan).' },
        { id: 16, name: 'Izin Usaha Jasa Pertambangan (IUJP)' },
        { id: 17, name: 'Sertifikat Badan Usaha Jasa Konstruksi (SBUJK)' },
        { id: 18, name: 'Izin Usaha Jasa Perusahaan Tenaga Listrik (IUJPTL)' },
        {
          id: 11,
          name: 'Surat Keterangan Domisili / Surat Izin Tempat Usaha (SITU).',
        },
        { id: 13, name: 'TDP (Tanda Daftar Perusahaan).' },
        { id: 19, name: 'Izin Usaha Niaga Umum Bahan Bakar Minyak (INU BBM)' },
        { id: 20, name: 'Surat Izin Usaha Perusahaan Angkatan Laut (SIUPAL)' },
        { id: 21, name: 'Izin Perusahaan Penyedia Tenaga Kerja Jasa / Buruh' },
        { id: 22, name: 'Surat Izin Usaha Perusahaan Bongkar Muat (SIUPBM)' },
      ],
      izin2: [
        { id: 23, name: 'Surat Izin Usaha Jasa Survey (SIUJS)' },
        { id: 37, name: 'Izin Usaha Angkutan Sungai Danau' },
        {
          id: 24,
          name:
            'Surat Izin Usaha Pengurusan Angkutan Jasa / Transportasi (SIUJPT)',
        },
        { id: 26, name: 'Surat Izin Pengelolaan Limbah (SIPL)' },
      ],
    }
  },
  methods: {
    async exportToPDF() {
      this.isVisible = true
      this.isLoading = true
      await html2pdf(this.$refs.document, {
        margin: 0.2,
        filename: 'Formulir Vendor Badan Usaha.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      })
      this.isVisible = false
      this.isLoading = false
    },
  },
}
</script>
